var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ready
    ? _c("div", { staticClass: "warranty-card" }, [
        _c("div", { staticClass: "data-item" }, [
          _c("span", { staticClass: "label" }, [_vm._v("Status:")]),
          _vm._v(" "),
          _c(
            "strong",
            {
              class: {
                value: true,
                "in-warranty": _vm.data.in_warranty,
                "out-of-warranty": !_vm.data.in_warranty,
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.data.status) + "\n    ")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "data-item" }, [
          _c("span", { staticClass: "label" }, [_vm._v("Activation Date:")]),
          _vm._v(" "),
          _vm.data.activation_date
            ? _c(
                "span",
                { staticClass: "value" },
                [
                  _c("time-zone-formatter", {
                    attrs: { "current-time": _vm.activationDate },
                  }),
                ],
                1
              )
            : _c("span", { staticClass: "value" }, [_vm._v("N/A")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "data-item" }, [
          _c("span", { staticClass: "label" }, [_vm._v("Limited Expiration:")]),
          _vm._v(" "),
          _vm.data.standard_expiration
            ? _c(
                "span",
                { staticClass: "value" },
                [
                  _c("time-zone-formatter", {
                    attrs: { "current-time": _vm.standardExpirationDate },
                  }),
                ],
                1
              )
            : _c("span", { staticClass: "value" }, [_vm._v("N/A")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "data-item" }, [
          _c("span", { staticClass: "label" }, [_vm._v("Extended Warranty:")]),
          _vm._v(" "),
          _c("strong", { staticClass: "value" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.data.extended_warranty ? "Yes" : "No") +
                "\n    "
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.data.notes
          ? _c("div", { staticClass: "notes" }, [
              _c("strong", { staticClass: "notes-title" }, [_vm._v("Notes:")]),
              _vm._v("\n    " + _vm._s(_vm.data.notes) + "\n  "),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }